// extracted by mini-css-extract-plugin
module.exports = {"modal":"AssignPatientsModal_modal__3NBAT"};